import { type ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '@/components/link';
import { cn } from '@/lib/utils';
import logo from '/images/brd-logo.svg';
import Switchers from './switchers';

export interface FooterLogoSectionProps {
    className?: string;
}

/**
 * Renders the footer's middle row: the brand logo and the (existing) site/country
 * selector — see {@link Switchers}.
 */
export default function FooterLogoSection({ className }: FooterLogoSectionProps): ReactElement {
    const { t } = useTranslation('footer');

    return (
        <div
            className={cn(
                'flex flex-col items-start gap-4 border-b border-footer-border py-4 sm:flex-row sm:items-center sm:justify-between',
                className
            )}>
            <Link to="/">
                <img src={logo} alt={t('logoAlt')} className="h-[26px] w-auto" />
            </Link>
            <Switchers className="bg-background border border-footer-border" />
        </div>
    );
}
